import { Component, inject } from '@angular/core';
import { Guid } from 'guid-typescript';
import { BtwTextBoxModule } from '@between/ng-cdk/text-box';
import { BtwLabelModule } from '@between/ng-cdk/label';
import { GenericIndicatorAnalysisComponent } from '../analyses/generic-indicator-analysis/generic-indicator-analysis.component';
import { StackedIndicatorAnalysisComponent } from '../analyses/stacked-indicator-analysis/stacked-indicator-analysis.component';
import { FinancialStatementAnalysisComponent } from '../analyses/financial-statement-analysis/financial-statement-analysis.component';
import { AuthService } from '../core/services/auth.service';
import { FormsModule } from '@angular/forms';
import { BtwButtonModule } from '@between/ng-cdk/button';

@Component({
  selector: 'app-analysis',
  standalone: true,
  imports: [
    FormsModule, 
    BtwLabelModule, 
    BtwTextBoxModule, 
    BtwButtonModule, 
    GenericIndicatorAnalysisComponent,
    StackedIndicatorAnalysisComponent,
    FinancialStatementAnalysisComponent],
  templateUrl: './analysis.component.html',
  styleUrl: './analysis.component.scss'
})
export class AnalysisComponent {
  private readonly authService: AuthService = inject(AuthService);

  analysisId?: Guid;
  apiKey?: Guid;

  handleSubmit(): void {
    this.authService.setApiKey(this.apiKey!);
  }
}
